import React from 'react';
import './spinner.scss'

const Spinner = ({className = ''}) => <span className={`spinner loader ${className}`} role='log'/>;

export default Spinner;